interface HasJestGuest {
  jestGuest?: boolean;
}

// A user counts as registered ONLY when jestGuest is explicitly false.
// Missing/undefined (a stale build, or an /api/auth/me that omitted the field)
// is treated as NOT registered — fail safe. Guarding on `!user.jestGuest`
// instead would treat unknown as registered, which lets a guest hit the
// registered-only Sign Out and hides their Create Account prompt.
export function isRegisteredUser(
  user: HasJestGuest | null | undefined,
): boolean {
  return user?.jestGuest === false;
}
